import { render, staticRenderFns } from "./TableAddMaterials.vue?vue&type=template&id=369732db"
import script from "./TableAddMaterials.vue?vue&type=script&lang=js"
export * from "./TableAddMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports